import { ITokenBasedSession } from '..';
import { IEvent } from '../../event-aggregation-service';
import { SessionServiceEventType } from '../enums/event-types';

export class SessionCreatedEvent implements IEvent {

	public readonly timestamp: Date;
	public readonly eventType = SessionCreatedEvent.EventType;
	public readonly session: ITokenBasedSession;

	public static EventType = SessionServiceEventType.SESSION_CREATED;

	constructor(session: ITokenBasedSession) {
		this.timestamp = new Date();
		this.session = session;
	}
}
